import React, { useContext } from 'react';
import { Provider } from 'react-redux';
import { createStore } from 'redux-dynamic-modules';
import { getSagaExtension } from 'redux-dynamic-modules-saga';
import {
  BaseAppWrapperContext,
  ReduxModule
} from '../../BaseAppProvider/BaseAppProvider';

const store = (reduxModules: ReduxModule[]) =>
  createStore<any>(
    {
      initialState: {},
      enhancers: [],
      extensions: [getSagaExtension({})]
    },
    ...reduxModules
  );

const getArrayFromVal = (val: ReduxModule[] | undefined) => {
  if (val) return val;

  return [];
};

export const reduxProviderHocSetup = (
  additionalReduxModules?: ReduxModule[]
) => (WrappedComponent: React.FC<any>) => {
  const getStoreModules = (contextReduxModules?: ReduxModule[]) => [
    ...getArrayFromVal(additionalReduxModules),
    ...getArrayFromVal(contextReduxModules)
  ];

  return (props: any) => {
    const { reduxModules } = useContext(BaseAppWrapperContext);

    return (
      <Provider store={store(getStoreModules(reduxModules?.current))}>
        <WrappedComponent {...props} />
      </Provider>
    );
  };
};
